export type PlayerPosition = 'center' | 'bottom' | 'top' | 'left' | 'right' | 'top-left' | 'top-right';

export function getPlayerPosition(
  playerId: string | null,
  myPlayerId: string,
  players: { playerId: string }[]
): PlayerPosition {
  if (!playerId) return 'center';
  if (playerId === myPlayerId) return 'bottom';

  const myIndex = players.findIndex((p) => p.playerId === myPlayerId);
  const theirIndex = players.findIndex((p) => p.playerId === playerId);
  if (myIndex === -1 || theirIndex === -1) return 'center';

  const offset = (theirIndex - myIndex + players.length) % players.length;

  if (players.length === 2) {
    if (offset === 1) return 'top';
  } else if (players.length === 3) {
    if (offset === 1) return 'left';
    if (offset === 2) return 'right';
  } else if (players.length === 4) {
    if (offset === 1) return 'left';
    if (offset === 2) return 'top';
    if (offset === 3) return 'right';
  } else if (players.length === 5) {
    if (offset === 1) return 'left';
    if (offset === 2) return 'top-left';
    if (offset === 3) return 'top-right';
    if (offset === 4) return 'right';
  }
  return 'center';
}
